module.exports = angular.module(__filename, [
    require('../components/dropdown/dropdown').name
]).component("alertFilters", {
    bindings: {
        alert: '<',
        channels: '<',
        type: '<',
        sentimentDetection: '<',
        alertChangeDirection: '<',
        onChannelChanged: '&'
    },
    template: '<ng-include src="$ctrl.getTemplateUrl()"/>',
    controller: ['$scope', '$rootScope', 'util', function ($scope, $rootScope, util) {
        this.$onInit = function () {
            this.geos = $rootScope.Geos.geos;
        };

        this.onGeoSelected = function (geo) {
            this.alert.geo = geo;
        };

        this.onSentimentSelected = function (sentimentDetection) {
            this.alert.sentiment = sentimentDetection;
        };

        this.onSentimentEventSelected = function (change) {
            this.alert.change = change;
        };

        this.getTemplateUrl = function () {
            return `partials/${this.type}-filter.partial.html`;
        };

        this.getButtonCss = (option, currentVal) => util.getButtonCss(option, currentVal, $scope);

        this.changeChannel = function (channel) {
            this.alert.channel = channel;
            if (this.alert.channel == 'tweets') {
                this.alert.benchmark_timeframe = 'last_month';
            }

            this.onChannelChanged({$event: channel})
        };
    }]
});
